import * as twgl from 'twgl.js';

import { wbgl_type } from './Wbgl.js';
import { shdr_type } from './Shdr.js';
import { loop_type } from './Loop.js';
import { scrn_type } from './Scrn.js';

import { M2 } from './M2.js';
import { XY } from './V2.js';

import { Rndm } from './Rndm.js';
import { Arry } from './Arry.js';

export interface wbgl_mono_type {
    id: string;
    shader: shdr_type;
    mesh: Float32Array;
    buffer: any;
    uniforms: any;
    mesh_update: (new_mesh: Float32Array) => void;
    mesh_xy: (xy: XY) => void;
    mesh_transform: (xyzr?: {
        x: number;
        y: number;
        z: number;
        r: number;
    }) => void;
    mesh_set: (mesh: Float32Array) => void;
    uniforms_set: (io: any) => void;
    render: (Time?: loop_type, Screen?: scrn_type) => void;
    kill: () => void;
}

export interface wbgl_mono_manager_type {
    list: wbgl_mono_type[];
    run: () => void;
    get: (id: string) => any;
    kill: (id: string) => void;
    make: (Wbgl: wbgl_type, Shdr: shdr_type, Scrn: scrn_type, io: any) => wbgl_mono_type;
}

export const Wbgl_mono = {
    list: [] as wbgl_mono_type[],
    run: function () {
        for (const g of this.list) {
            g.render();
        }
    },
    get: function (id: string) {
        return Arry.get.id(this.list, id);
    },
    kill: function (id: string) {
        const g = this.get(id);
        if (g) g.kill();
    },
    make: function (Wbgl: wbgl_type, Shdr: shdr_type, Scrn: scrn_type, io: any): wbgl_mono_type {

        const l = {
            id: io.id || Rndm.id(),
            shader: Shdr,
            mesh: io.mesh as Float32Array,
            buffer: undefined as any,
            uniforms: io.uniforms || {},
            mesh_update: function (new_mesh: Float32Array) { //same triangle count
                M2.sets(this.mesh, new_mesh);
                twgl.setAttribInfoBufferFromArray(Wbgl.context, this.buffer.attribs.position, this.mesh);
            },
            mesh_xy: function (xy: XY) {
                twgl.setAttribInfoBufferFromArray(Wbgl.context, this.buffer.attribs.position, M2.new.offsets(this.mesh, xy.x, xy.y));
            },
            mesh_transform: function (xyzr = { x: 0, y: 0, z: 1, r: 0 }) {
                twgl.setAttribInfoBufferFromArray(Wbgl.context, this.buffer.attribs.position, M2.new.transforms({ mesh: this.mesh, x: xyzr.x, y: xyzr.y, scale: xyzr.z, rotation: xyzr.r }));
            },
            mesh_set: function (mesh: Float32Array) {
                this.mesh = mesh;
                this.buffer = twgl.createBufferInfoFromArrays(Wbgl.context, { position: { numComponents: 2, data: this.mesh } });
            },
            uniforms_set: function (io: any) {
                for (const att in io) {
                    this.uniforms[att] = io[att];
                }
            },
            render: function (Time?: loop_type, Screen?: scrn_type) {

                if (Time) this.uniforms.u_time = Time.now * 0.01;
                if (Screen) {
                    this.uniforms.u_screen[0] = Screen.screen[0];
                    this.uniforms.u_screen[1] = Screen.screen[1];
                }
                Wbgl.context.useProgram(l.shader.compiled.program);
                twgl.setBuffersAndAttributes(Wbgl.context, l.shader.compiled, this.buffer);
                twgl.setUniforms(l.shader.compiled, this.uniforms);
                twgl.drawBufferInfo(Wbgl.context, this.buffer, Wbgl.context.TRIANGLES);
            },
            kill: function () {
                Arry.remove.id(Wbgl_mono.list, this.id);
            }
        };

        l.uniforms = { ...io.uniforms, u_screen: Scrn.screen, u_time: 0 };
        l.buffer = twgl.createBufferInfoFromArrays(Wbgl.context, { position: { numComponents: 2, data: l.mesh } });

        this.list.push(l);
        return l;
    }
};
